const MAX_GALLERY_SEARCH_LENGTH = 80;

export function normalizeGallerySearch(
  value: string | string[] | null | undefined
): string {
  const raw = Array.isArray(value) ? value[0] : value;
  return typeof raw === "string"
    ? raw.trim().slice(0, MAX_GALLERY_SEARCH_LENGTH)
    : "";
}

export function withGallerySearchParam(href: string, search: string): string {
  const normalized = normalizeGallerySearch(search);
  if (!normalized) return href;

  const [pathname, query = ""] = href.split("?");
  const params = new URLSearchParams(query);
  params.set("q", normalized);
  return `${pathname}?${params.toString()}`;
}
